import { createContext, useContext } from 'react';

export type Brand = typeof process.env.REACT_APP_BRAND;

export const BrandContext = createContext(process.env.REACT_APP_BRAND);

/* Get current brand. */
export const useBrand = () => useContext(BrandContext);
